// Compatibility aliases for the preset values in chart-presets.tsx.
import { CHART_PRESET, CHART_TICK_STYLE } from './chart-presets';

export const CARTESIAN_GRID_STROKE = CHART_PRESET.gridStroke;
export const CARTESIAN_GRID_STROKE_WIDTH = CHART_PRESET.gridStrokeWidth;
export const CHART_MARGIN_WITH_LEGEND = { top: 10, right: 10 };
export const LINE_STROKE_WIDTH = CHART_PRESET.lineStrokeWidth;
export const TICK_STYLE = CHART_TICK_STYLE;
export const X_AXIS_PADDING = { left: 15, right: 15 };
